<template>
    <div id="viproomview">
        <div v-if="mediaOpen && started" >
            <Navigator id="topbar" :unclickable="true"></Navigator>
        </div>
        <div v-else>
            <Navigator id="topbar"></Navigator>
        </div>
        <div v-if="!started" class="fullwin container text-center">
            <div style="height: 100%">
                <div class="card mt-5">
                    <div class="card-body text-dark">
                        <h4>You are about to start a Kalameeting</h4>
                        <p>
                            <Video id="preview" :muted="true" :stream="localStream"
                                   :vid-height="370" :vid-width="400" :callback="resize">
                            </Video>
                        </p>
                        <div v-if="!mediaOpen">
                            <p>Make sure your camera and microphone are working.</p>
                            <b-button pill @click="openMedia">
                                Enable Camera And Microphone
                            </b-button>
                        </div>
                        <div v-if="mediaOpen">
                            <p>All set! You can start the session now! </p>
                            <b-button pill @click="startSession">Start Session</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="mediaOpen && started" class="fullwin container-fluid text-center">
            <div id="timer" v-if="timer">
                <p :class="timercolor"><i class="material-icons">alarm_on</i>
                    <span id="timercount">{{timer}}</span></p>
            </div>
            <div class="row h-100 align-items-center" id="videorow">
                <div id="selfiemode" class="row h-100 align-items-center text-center"
                     v-if="selfiemode">
                    <canvas id="canvas" style="display:none"></canvas>
                    <img id="logotemp" style="display:none"
                         src="../../assets/images/kalamaio-templogo.svg"/>
                    <div id="photowrap" class="output" style="display:none">
                        <img id="photo" alt="The screen capture will appear in this box.">
                        <br><br>
                        <b-button pill class="m-3 text-dark"
                                  :download="filename" :href="picture">
                            Download</b-button>
                    </div>
                    <div id="selfiewrap" >
                        <Video id="localVideoSelfie" :muted="true" :stream="localStream"
                               :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                        <Video id="remoteVideoSelfie" :muted="false" :stream="remoteStream"
                               :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                    </div>
                    <div id="selfiecontrolbar"
                         class="col-12 text-center align-items-center">
                        <b-button v-if="selfieDone" id="tryAgain" class="ctr-btn" @click="tryAgain">
                            <i class="material-icons">refresh</i>
                        </b-button>
                        <b-button v-if="!selfieDone" id="closeSelfie"
                                  class="ctr-btn" @click="clickSelfie">
                            <i class="material-icons">camera_alt</i>
                        </b-button>
                        <b-button v-if="selfieDone" id="okSelfie" class="ctr-btn" @click="okSelfie">
                            <i class="material-icons">check</i>
                        </b-button>
                        <b-button v-if="!selfieDone" id="close"
                                  class="ctr-btn" @click="closeSelfie">
                            <i class="material-icons">close</i>
                        </b-button>
                    </div>
                </div>
                <div id="vid1" v-if="!selfiemode" class="vidwrap">
                    <Video id="localVideo" :muted="true" :stream="localStream"
                           :vid-height="vidHeight" :vid-width="vidWidth" :callback="resize"/>
                </div>
                <div id="vid2" v-if="!selfiemode" class="vidwrap">
                    <Video id="remoteVideo" :muted="false" :stream="remoteStream"
                           :vid-height="vidHeight" :vid-width="vidWidth"/>
                    <!--      <div v-if="mediaOpen && started" style="position:absolute;
                    margin-top:-20px">-->
                    <!--      <b-button pill @click="hangUp">Hang Up</b-button>-->
                    <!--                    </div>-->
                </div>
            </div>
            <div id="controlbar" v-if="!selfiemode">
                <b-button id="pauseTimer" class="ctr-btn" variant="dark" @click="pauseTimer">
                    <i class="material-icons">pause</i>
                </b-button>
                <b-popover variant="dark" target="pauseTimer" triggers="hover" placement="top">
                    <template v-slot:title>Take a break</template>
                    You can resume the conversation with the user at any time.
                </b-popover>
                <b-button id="requestSelfie" class="ctr-btn" @click="takeASelfie">
                    <i class="material-icons">portrait</i>
                </b-button>
                <b-popover variant="dark" target="requestSelfie"
                           triggers="hover" placement="top">
                    <template v-slot:title>Selfie Mode</template>
                    Go in selfie mode to take a selfie
                </b-popover>
                <b-button id="endcall" class="ctr-btn" variant="danger" @click="hangUp">
                    <i class="material-icons">call_end</i>
                </b-button>
                <b-popover variant="dark" target="endcall" triggers="hover" placement="top">
                    <template v-slot:title>End your call</template>
                    You can exit the call at any time.
                </b-popover>
            </div>
        </div>
        <div id="lowbar">
        </div>
    </div>
</template>

<style>
    #selfiemode {
        background: #1abc9c;
        margin:0;
        right: 0;
        position: relative;
        height: 100%;
        width: 100%;
        top: 0;
        z-index: 2;
    }
    #selfiemode #selfiewrap, #selfiemode #photowrap {
        border: 3px #ffc000 groove;
        object-fit: cover;
        overflow: hidden;
        border-radius: 20px;
        position: relative;
        top:0;
        left:0;
        margin: auto;
        vertical-align: middle;
        align-content: center;
        align-items: center;
    }

    #selfiemode Video {
        border: 0;
        border-radius: 0px;
    }

    #selfiecontrolbar {
        background: #1abc9c;
        position: relative;
        left:0;
    }

    #selfiecontrolbar .ctr-btn {
        margin: 20px 5px;
        color: white;
        width: 50px;
        height: 50px;
        border-radius: 50px;
        border-width: 0;
    }
    #selfiecontrolbar i{
        font-size: 25px;
        display: inline;
        vertical-align: middle;
    }
    #viproomview {
        width: 100%;
        height: 100%;
        position: fixed;
        background: #06424d;
        color: white;
    }

    #timer {
        position: relative;
        z-index: 1999001;
        width: 100%;
    }

    #timer p {
        font-size: 20px;
        width: 150px;
        border-radius: 20px;
        margin: auto;
        margin-top: -55px;
        padding: 4px;
        background-color: #92D050dd;
        color: #06424d;
    }
    #timer span {
        display: inline;
        vertical-align: middle;
    }
    #timer i {
        display: inline;
        vertical-align: middle;
        font-size: 30px;
    }
    #lowbar {
        min-height: 5rem;
        height:5%;
    }

    Video {
        border: 3px #ffc000 groove;
        object-fit: cover;
        overflow: hidden;
        border-radius: 20px;
    }

    #controlbar {
        position: relative;
        width: 100%;
        top:-25px;
    }

    #controlbar .ctr-btn {
        margin: 20px 5px;
        color: white;
        width: 60px;
        height: 60px;
        border-radius: 60px;
        border-width: 0;
    }
    #controlbar i {
        font-size: 30px;
        display: inline;
        vertical-align: middle;
    }
    #requestSelfie{
        margin-top: 0;
        border-radius: 60px;
        width: 60px;
        height: 60px;
    }
</style>
<script>
import firebase from '../../firebase';
import Video from '../../components/kalameeting/Video.vue';
import Navigator from '../../components/Navigator.vue';

const configuration = {
    iceServers: [{
        urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302']
    }],
    iceCandidatePoolSize: 10
};


const vm = {
    data() {
        return {
            roomId: '',
            owner: this.$store.state.currentUser.uid,
            guest: null,
            mediaOpen: false,
            started: false,
            peerConnection: null,
            channel: null,
            localStream: null,
            remoteStream: null,
            vidHeight: 0,
            vidWidth: 0,
            timer: null,
            timerActive: null,
            timercolor: 'bg-primary',
            selfiemode: false,
            selfieDone: false,
            canvas: null,
            photo: null,
            picture: null,
            meetingId: null
        };
    },
    computed: {
        filename() {
            return `Kalamemories-${this.meetingId}.png`;
        }
    },
    components: {
        Navigator,
        Video
    },
    watch: {
        timer() {
            const min = this.timer.split(':')[0];
            const sec = this.timer.split(':')[1];
            if (min < 1 && sec < 11) {
                this.timercolor = 'bg-danger';
            } else if (min < 1 && sec < 31) {
                this.timercolor = 'bg-warning';
            }
        },
        selfiemode() {
            this.sendMessage({ selfiemode: { value: this.selfiemode } });
        },
        picture() {
            if (this.picture) {
                firebase.meetingImages.child(this.meetingId)
                    .putString(this.picture, 'data_url')
                    .then(() => {
                        console.log('Image uploaded');
                        firebase.meetingsCollection.doc(this.meetingId)
                            .update({
                                pic: true
                            });
                        this.sendMessage({ picture: { value: true } });
                    })
                    .catch((err) => {
                        console.log('Error while uploading image');
                        console.log(err);
                        this.sendMessage({ picture: { value: false } });
                    });
            } else {
                this.sendMessage({ picture: { value: false } });
            }
        },
        meetingId() {
            this.sendMessage({ meetingId: { value: this.meetingId } });
        },
        selfieDone(done) {
            if (done) {
                const photowrap = document.getElementById('photowrap');
                const selfiewrap = document.getElementById('selfiewrap');
                photowrap.style.display = 'block';
                selfiewrap.style.display = 'none';
                this.photo = document.getElementById('photo');
                this.photo.setAttribute('src', this.picture);
            } else {
                const photowrap = document.getElementById('photowrap');
                const selfiewrap = document.getElementById('selfiewrap');
                photowrap.style.display = 'none';
                selfiewrap.style.display = 'block';
                this.photo = null;
            }
        }
    },
    methods: {
        openMedia() {
            const preview = document.getElementById('preview');
            navigator.mediaDevices.getUserMedia({
                audio: true,
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                }
            })
                .then((stream) => {
                    this.localStream = stream;
                    this.mediaOpen = true;
                    this.remoteStream = new MediaStream();
                    preview.srcObject = this.localStream;
                })
                .catch((err) => {
                    console.log('Failed to obtain User Media', err);
                    alert('Unfortunately your browser is not supported. Please try using another device');
                });
        },
        async startSession() {
            console.log('Starting Call');
            const audioTracks = this.localStream.getAudioTracks();
            const videoTracks = this.localStream.getVideoTracks();
            if (audioTracks.length > 0) {
                console.log(`Using audio device: ${audioTracks[0].label}`);
            }
            if (videoTracks.length > 0) {
                console.log(`Using video device: ${videoTracks[0].label}`);
            }
            const roomRef = firebase.roomsCollection.doc(this.roomId);
            this.peerConnection = new RTCPeerConnection(configuration);
            this.channel = this.peerConnection.createDataChannel('sendChannel');
            this.startPeerConnectionListeners();

            this.localStream.getTracks().forEach((track) => {
                this.peerConnection.addTrack(track, this.localStream);
            });

            const callers = roomRef.collection('callers');
            this.peerConnection.addEventListener('icecandidate', (event) => {
                if (!event.candidate) {
                    console.log('Got final candidate!');
                    return;
                }
                console.log('Got candidate: ', event.candidate);
                callers.add(event.candidate.toJSON());
            });

            const offer = await this.peerConnection.createOffer({
                offerToReceiveAudio: 1,
                offerToReceiveVideo: 1
            });
            await this.peerConnection.setLocalDescription(offer);
            console.log('Offer created');

            const roomWithOffer = {
                owner: this.$store.state.currentUser.uid,
                offer: {
                    type: offer.type,
                    sdp: offer.sdp
                }
            };

            await roomRef.set(roomWithOffer);
            console.log('Room created');

            this.peerConnection.addEventListener('track', (event) => {
                console.log('Got Remote track:', event.streams[0]);
                event.streams[0].getTracks().forEach((track) => {
                    console.log('Add a track to remoteStream ', track);
                    this.remoteStream.addTrack(track);
                });
            });

            roomRef.onSnapshot(async (snapshot) => {
                const data = snapshot.data();
                console.log(data);
                if (!this.peerConnection.currentRemoteDescription
                    && data && data.answer && data.guest) {
                    console.log('uid', data.guest);
                    this.guest = data.guest;
                    console.log('Got Remote Description: ', data.answer);
                    const rtcSessionDescription = new RTCSessionDescription(data.answer);
                    await this.peerConnection.setRemoteDescription(rtcSessionDescription);
                }
            });

            const callees = roomRef.collection('callees');
            callees.onSnapshot((snapshot) => {
                snapshot.docChanges().forEach(async (change) => {
                    if (change.type === 'added') {
                        const data = change.doc.data();
                        console.log('Got new Remote ICE Candidate');
                        await this.peerConnection.addIceCandidate(new RTCIceCandidate(data));
                    }
                });
            });

            this.started = true;
            this.resize();
        },
        startPeerConnectionListeners() {
            this.peerConnection.addEventListener('connectionstatechange', () => {
                console.log(`Connection state change: ${this.peerConnection.connectionState}`);
            });
            this.peerConnection.addEventListener('signalingstatechange', () => {
                console.log(`Signaling state change: ${this.peerConnection.signalingState}`);
            });
            this.peerConnection.addEventListener('iceconnectionstatechange', () => {
                console.log(`ICE Connection state change: ${this.peerConnection.iceConnectionState}`);
            });
            this.peerConnection.addEventListener('icegatheringstatechange', () => {
                console.log(`ICE gathering state changed: ${this.peerConnection.iceGatheringState}`);
            });
            this.channel.addEventListener('open', () => {
                console.log(`Channel Status: ${this.channel.readyState}`);
                this.startTimer();
            });
            this.channel.addEventListener('close', () => {
                console.log(`Channel Status: ${this.channel.readyState}`);
                this.pauseOrResetTimer();
                alert('Your peer disconnected');
                this.hangUp();
            });
            this.channel.addEventListener('message', (event) => {
                console.log(`Message Received: ${JSON.parse(event.data)}`);
            });
        },
        sendMessage(message) {
            console.log(`Sending message ${JSON.stringify(message)}`);
            this.channel.send(JSON.stringify(message));
        },
        startTimer() {
            this.timerActive = setInterval(async () => {
                const end = new Date();
                let minutes;
                let seconds;
                end.setMilliseconds(0);
                if (!this.timer) {
                    end.setSeconds(end.getSeconds() + 5);
                    end.setMinutes(end.getMinutes()
                        + this.$store.state.kalameetingDetails.timeSlot);
                    firebase.roomsCollection.doc(this.roomId)
                        .update({ timer: { status: 'running', end: end.getTime() } });
                    this.sendMessage({ timer: { status: 'running', end: end.getTime() } });
                    const now = new Date();
                    const distance = end - now;
                    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    seconds = Math.floor((distance % (1000 * 60)) / 1000);
                    const meeting = firebase.meetingsCollection.doc();
                    await meeting.set({
                        owner: this.owner,
                        guest: this.guest,
                        kalameeting: this.$store.state.currentKalameeting,
                        pic: false,
                        length: this.$store.state.kalameetingDetails.timeSlot,
                        date: new Date().getTime(),
                        status: 'STARTED'
                    });
                    this.meetingId = meeting.id;
                    console.log(`New meeting created ${meeting.id}`);
                } else {
                    end.setMinutes(this.timer.split(':')[0]);
                    end.setSeconds(this.timer.split(':')[1]);
                    end.setSeconds(end.getSeconds() - 1);
                    minutes = end.getMinutes();
                    seconds = end.getSeconds();
                }
                if (minutes < 1 && seconds < 1) {
                    clearInterval(this.timerActive);
                    this.finishMeeting();
                }
                this.timer = `${(minutes < 10 ? '0' : '') + minutes}:
                ${(seconds < 10 ? '0' : '') + seconds}`;
            }, 1000);
        },
        pauseOrResetTimer() {
            clearInterval(this.timerActive);
            firebase.roomsCollection.doc(this.roomId)
                .update({ timer: { status: 'paused', remaining: this.timer } });
            this.timer = null;
        },
        finishMeeting() {
            firebase.meetingsCollection.doc(this.meetingId)
                .update({
                    owner: this.owner,
                    guest: this.guest,
                    kalameeting: this.$store.state.currentKalameeting,
                    pic: '',
                    length: this.$store.state.kalameetingDetails.timeSlot,
                    date: new Date().getTime(),
                    status: 'COMPLETED'
                });
            this.hangUp();
        },
        pauseTimer() {
            alert('Feature not yet implemented');
        },
        takeASelfie() {
            this.selfiemode = true;
            this.canvas = document.getElementById('canvas');
            this.photo = document.getElementById('photo');
            this.clearPhoto();
            this.resize();
        },
        clickSelfie() {
            this.canvas = document.getElementById('canvas');
            this.photo = document.getElementById('photo');
            const localVideo = document.getElementById('localVideoSelfie');
            const remoteVideo = document.getElementById('remoteVideoSelfie');
            const context = this.canvas.getContext('2d');
            if (this.vidWidth && this.vidHeight) {
                const width = localVideo.videoWidth;
                const height = (this.vidHeight * localVideo.videoWidth) / this.vidWidth;
                const logoheight = ((width / 2) / 100) * 19;
                this.canvas.width = width * 2;
                this.canvas.height = height + logoheight;
                context.fillStyle = '#06424d';
                context.fillRect(0, 0, this.canvas.width, this.canvas.height);
                let localsx = 0;
                let localsy = 0;
                let localsw = localVideo.videoWidth;
                let localsh = localVideo.videoHeight;
                if (localVideo.videoHeight > localVideo.videoWidth) {
                    localsy = (localVideo.videoHeight - height) / 2;
                    localsh = (localVideo.videoWidth / width) * height;
                } else {
                    localsx = (localVideo.videoWidth
                        - ((localVideo.videoHeight / height) * width)) / 2;
                    localsw = (localVideo.videoHeight / height) * width;
                }
                context.drawImage(localVideo,
                    localsx,
                    localsy,
                    localsw,
                    localsh,
                    0, 0,
                    width,
                    height);
                let remotesx = 0;
                let remotesy = 0;
                let remotesw = remoteVideo.videoWidth;
                let remotesh = remoteVideo.videoHeight;
                if (remoteVideo.videoHeight > remoteVideo.videoWidth) {
                    remotesy = (remoteVideo.videoHeight - height) / 2;
                    remotesh = (remoteVideo.videoWidth / width) * height;
                } else {
                    remotesx = (remoteVideo.videoWidth
                        - ((remoteVideo.videoHeight / height) * width)) / 2;
                    remotesw = (remoteVideo.videoHeight / height) * width;
                }
                context.drawImage(remoteVideo,
                    remotesx,
                    remotesy,
                    remotesw,
                    remotesh,
                    width, 0,
                    width, height);
                const logo = document.getElementById('logotemp');
                context.drawImage(logo, (width - ((width / 2) / 2)),
                    height - (logoheight / 3),
                    (width / 2),
                    logoheight);
                const data = this.canvas.toDataURL('image.png');
                this.picture = data;
                this.selfieDone = true;
            } else {
                this.clearPhoto();
            }
        },
        clearPhoto() {
            this.canvas = document.getElementById('canvas');
            this.picture = null;
            this.selfieDone = false;
        },
        tryAgain() {
            this.clearPhoto();
        },
        closeSelfie() {
            this.clearPhoto();
            this.canvas = null;
            this.photo = null;
            this.selfiemode = false;
            this.resize();
        },
        okSelfie() {
            this.clearPhoto();
            this.canvas = null;
            this.photo = null;
            this.selfiemode = false;
            this.resize();
        },
        hangUp() {
            this.timer = null;
            document.getElementById('videorow').style.display = 'block';
            console.log('Ending call');
            this.started = false;
            this.mediaOpen = false;
            this.localStream.getTracks().forEach((track) => {
                track.stop();
            });
            window.addEventListener('resize', () => {});
            this.peerConnection.close();
            this.$router.push({ name: 'FANFinalPage', params: { meetingId: this.meetingId } });
        },
        resize() {
            // if (this.mediaOpen && this.started) {
            const topbar = document.getElementById('topbar').offsetHeight;
            const lowbar = document.getElementById('lowbar').offsetHeight;
            const contentHeight = window.innerHeight - topbar - lowbar;
            const contentWidth = window.innerWidth;
            document.getElementsByClassName('fullwin')[0].style.height = `${contentHeight}px`;
            if (this.selfiemode) {
                if (contentHeight < ((contentWidth / 2) * 9) / 8) {
                    this.vidHeight = (contentHeight / 1.5);
                    this.vidWidth = ((contentHeight / 1.5) * 9) / 8;
                } else {
                    this.vidHeight = ((contentWidth / 2.15) * 8) / 9;
                    this.vidWidth = (contentWidth / 2.15);
                }
            } else if (contentHeight > contentWidth) {
                const vids = document.getElementsByClassName('vidwrap');
                vids.forEach((v, i) => {
                    vids[i].classList.remove('col-6');
                    vids[i].classList.add('col-12');
                });
                this.vidHeight = (contentHeight / 2.15);
                this.vidWidth = ((contentHeight / 2.15) * 1280) / 720;
            } else {
                const vids = document.getElementsByClassName('vidwrap');
                vids.forEach((v, i) => {
                    vids[i].classList.remove('col-12');
                    vids[i].classList.add('col-6');
                });
                if (contentHeight < ((contentWidth / 2) * 400) / 300) {
                    this.vidHeight = (contentHeight);
                    this.vidWidth = ((contentHeight) * 1280) / 720;
                } else {
                    this.vidHeight = ((contentWidth / 2.15) * 400) / 300;
                    this.vidWidth = (contentWidth / 2.15);
                }
            }
            // }
        }
    },
    created() {
        if (!this.$store.state.currentKalameeting) {
            this.$router.push('/');
        } else {
            this.roomId = this.$store.state.currentKalameeting;
        }
    },
    mounted() {
        this.resize();
        window.addEventListener('resize', () => {
            this.resize();
        });
        if (this.started) {
            document.addEventListener('beforeunload', this.hangUp());
            document.addEventListener('unload', this.hangUp());
        }
    }
};

export default vm;
</script>
